
export default {
  name: 'RankingArea',
  props: {
    index: {
      type: Number,
      default: undefined
    },
    idx: { // 상품 index
      type: Number,
      default: 0
    },
    ranking: {
      type: Object,
      default () { return {} }
    }
  },
}
